import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { ReviewerData } from '../../models';

export const upsertNominationReviewer: (
  fetchContext: FetchContext,
  nominationId: number,
  reviewerData: ReviewerData,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, reviewerData, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/nominations/${nominationId}/reviewers`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(reviewerData),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'upsert nomination reviewer'));
